import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import blackListByCustomersSaga from './sagas/blackListByCustomersSaga';
import blackListByExecutorsSaga from './sagas/blackListByExecutorsSaga';

export default [
  // Lists
  ...createCombineMapItem('blackListByCustomers', createListReduceObject, [
    blackListByCustomersSaga
  ]),
  ...createCombineMapItem('blackListByExecutors', createListReduceObject, [
    blackListByExecutorsSaga
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userBlackList/reducers/static/lists/reducersMap.js